/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login
 */

import authService from './../../../services/auth';
import configurationService from './../../../services/configuration';

export default {

  data() {
    return {
      user: {
        email: null,
        password: null,
        remember_me: 1,
      },
      detectScreenSize: window.matchMedia('(max-width: 1000px)'),
      showModalButton: false,
      smallLoading: false,
      topBarInfoStyle: {
        width: '100%',
        height: '30px',
        color: '#FFFFFF',
        backgroundColor: '#D7092E',
        paddingTop: '10px',
        paddingBottom: '10px',
      },
      topBarInfoText: '',
      topBarInfoEnabled: false,
    };
  },

  components: {
    VLoading: require('components/loading/loading.vue'),
  },

  mounted() {
    const vm = this;

    if (localStorage.getItem('isConfirmed') === 1) {
      toastr.success(vm.$t('register.after_confirm_alert'));
      localStorage.removeItem('isConfirmed');
    }

    vm.fetch_configuration();

    vm.showModal(vm.detectScreenSize);
    vm.detectScreenSize.addListener(vm.showModal);
  },

  methods: {
    showModal(ev) {
      if (ev.matches) {
        $('#modalBtn').click();
      }
    },

    async fetch_configuration() {
      const vm = this;
      const response = await configurationService.get(vm);
      vm.topBarInfoText = response.conf.top_bar_info_text;
      vm.topBarInfoEnabled = response.conf.top_bar_info_enabled;
      vm.topBarInfoStyle.backgroundColor = response.conf.top_bar_info_color;
    },

    async login(user) {
      this.smallLoading = true;
      await authService.login(user, this);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/login/index/index.js